export interface Asistencia {
  idAsistencia: number;
  idTrabajador: number;
  idPeriodo: number;
  fecha: string;
  horaEntrada: string | null;
  horaSalida: string | null;
  minutosTardanza: number;
  minutosPermiso: number;
  tipoAsistencia: string;
  justificado: boolean;
  horasTrabajadas: number;
  horasExtras25: number;
  horasExtras35: number;
  observaciones: string | null;
  trabajador?: { personal?: { personaContacto?: string } };
}

export interface Incidencia {
  idIncidencia: number;
  idTrabajador: number;
  idPeriodo: number;
  fechaInicio: string;
  fechaFin: string;
  tipoIncidencia: string;
  diasAfectados: number;
  minutosAfectados: number;
  afectaRemuneracion: boolean;
  observaciones: string | null;
  documentoSustento: string | null;
  trabajador?: { personal?: { personaContacto?: string } };
}

export interface ResumenAsistenciaTrabajador {
  idTrabajador: number;
  nombreTrabajador: string;
  diasLaborados: number;
  diasNoLaborados: number;
  faltas: number;
  faltasJustificadas: number;
  tardanzas: number;
  minutosTardanzaTotal: number;
  permisos: number;
  descansosMedicos: number;
  totalHorasTrabajadas: number;
  totalHorasExtras25: number;
  totalHorasExtras35: number;
}

export interface ResumenAsistenciaPeriodo {
  idPeriodo: number;
  anio: number;
  mes: number;
  totalTrabajadores: number;
  diasHabiles: number;
  detalle: ResumenAsistenciaTrabajador[];
}

export const TIPOS_ASISTENCIA = [
  { value: 'ASISTIO', label: 'Asistió', color: '#2e7d32' },
  { value: 'FALTA', label: 'Falta', color: '#d32f2f' },
  { value: 'TARDANZA', label: 'Tardanza', color: '#ed6c02' },
  { value: 'PERMISO', label: 'Permiso', color: '#0288d1' },
  { value: 'DESCANSO_MEDICO', label: 'Descanso Médico', color: '#7b1fa2' },
  { value: 'VACACIONES', label: 'Vacaciones', color: '#1565c0' },
  { value: 'FERIADO', label: 'Feriado', color: '#558b2f' },
];

export const TIPOS_INCIDENCIA = [
  { value: 'TARDANZA', label: 'Tardanza' },
  { value: 'FALTA_INJUSTIFICADA', label: 'Falta Injustificada' },
  { value: 'FALTA_JUSTIFICADA', label: 'Falta Justificada' },
  { value: 'PERMISO', label: 'Permiso' },
  { value: 'DESCANSO_MEDICO', label: 'Descanso Médico' },
  { value: 'SUSPENSION', label: 'Suspensión' },
  { value: 'LICENCIA', label: 'Licencia' },
];
